import { Menu } from '../../Menu/index.js'
import { Button } from '../../Button/index.js'
import { styled } from 'inlines'

export const ShowMetrics = ({
  stats,
  visibleMetric,
  setVisibleMetric,
  disabled,
  size,
}) => {
  const metricString =
    visibleMetric === 'words'
      ? `${stats.wordCount < 1 ? 'no words' : stats.wordCount > 1 ? stats.wordCount + ' words' : '1 word'}`
      : `${stats.characterCount < 1 ? 'no characters' : stats.characterCount > 1 ? stats.characterCount + ' characters' : '1 character'}`

  return (
    <styled.div>
      <Menu>
        <Menu.Trigger>
          <Button
            variant="ghost"
            size={size}
            trailIcon="tiny-chevron-down"
            //   forceHover={open}
            disabled={disabled}
          >
            {metricString}
          </Button>
        </Menu.Trigger>
        <Menu.Items>
          <Menu.Header>Show metric...</Menu.Header>
          <Menu.ToggleItem
            toggled={visibleMetric === 'words'}
            value={visibleMetric === 'words'}
            onChange={() => {
              setVisibleMetric('words')
            }}
          >
            words
          </Menu.ToggleItem>
          <Menu.ToggleItem
            toggled={visibleMetric === 'characters'}
            value={visibleMetric === 'characters'}
            onChange={() => {
              setVisibleMetric('characters')
            }}
          >
            characters
          </Menu.ToggleItem>
        </Menu.Items>
      </Menu>
    </styled.div>
  )
}
